import { Observable } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../core/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

import * as fromAppActions from '../../../core/state/app.actions';
import { AppState } from '../../../core/state/app.reducer';
import { stat } from 'fs';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-signin',
	templateUrl: './signin.component.html',
	styleUrls: ['./signin.component.scss'],
})
export class SigninComponent implements OnInit {
	fieldTextType: boolean;
	loginForm: FormGroup;
	state: boolean = false;
	logado: any;
	logging: Observable<Boolean>;

	constructor(
		private fb: FormBuilder,
		private store: Store<AppState>,
		private authService: AuthService,
		private translate: TranslateService,
		private activeRoute: ActivatedRoute
	) {}

	ngOnInit(): void {
		this.store.subscribe((state: any) => {
			this.logging = state.authContext.logging;
			this.state = state.authContext.authenticated;
			this.logado = state.authContext.user;
		});

		localStorage.clear();
		this.initPassForm();

		if (this.state && this.logado) {
			this.authService.logout();
		}

		const queryParams = this.activeRoute.snapshot.queryParams;
		const trial = queryParams.trial == 'true' || false;

		if (trial) {
			this.trialSignIn();
		}
	}

	initPassForm(): void {
		this.loginForm = this.fb.group({
			password: ['', Validators.required],
			email: ['', [Validators.required, Validators.email]],
			updateOn: 'blur',
		});
	}

	signIn(): void {
		const email = this.loginForm.value.email;
		const password = this.loginForm.value.password;

		localStorage.setItem('emergencyMeaningAlert', 'false');
		this.store.dispatch(fromAppActions.doLogin({ email, password }));
	}

	trialSignIn(): void {
		const email = 'rebom83981@lapeds.com';
		const password = 'SP@trial_user#2024';

		localStorage.setItem('emergencyMeaningAlert', 'false');
		this.store.dispatch(fromAppActions.doLogin({ email, password }));
	}

	toggleFieldTextType(): void {
		this.fieldTextType = !this.fieldTextType;
		this.changeIcon();
	}

	logout(): void {
		this.authService.logout();
	}

	changeIcon(): string {
		if (this.fieldTextType) {
			return 'visibility';
		} else {
			return 'visibility_off';
		}
	}
}
